import { HTMLAttributes } from 'react';
import {
  alignSelf,
  color,
  display,
  DisplayProps,
  fontFamily,
  fontSize,
  fontWeight,
  justifySelf,
  lineHeight,
  LineHeightProps,
  maxWidth,
  space,
  SpaceProps,
  textAlign,
} from 'styled-system';
import { ColoringProps, SelfPositioningProps, TypographyProps } from '~frontend-common/lib/styled-components';
import { styled } from '~ui-kit/styled-components';
import { theme } from '~ui-kit/theme';

export interface TextProps
  extends DisplayProps,
    SpaceProps,
    LineHeightProps,
    SelfPositioningProps,
    TypographyProps,
    HTMLAttributes<HTMLDivElement>,
    ColoringProps {
  color?: string;
}

/**
 * @deprecated DO NOT USE. Use ~ui-kit/components/Typography instead
 */
export const Text: React.SFC<TextProps> = styled.div`
  ${display};
  ${alignSelf};
  ${justifySelf};
  ${space};
  ${color};
  ${lineHeight};
  ${fontSize};
  ${fontWeight};
  ${fontFamily};
  ${textAlign};
  ${maxWidth};
` as any;

export interface TitleProps
  extends DisplayProps,
    SpaceProps,
    LineHeightProps,
    SelfPositioningProps,
    TypographyProps,
    HTMLAttributes<HTMLHeadingElement>,
    ColoringProps {
  color?: string;
}

Text.defaultProps = {
  color: 'text',
  fontSize: theme.fontSizes[3],
};
